import { LogNavigationButtons } from 'src/components'

import { ROUTES } from 'src/constants'

const buttons = [
  {
    label: 'quantity-type-nav-button.v',
    route: ROUTES.QUANTITY_TYPES,
  },
  {
    label: 'un-sdg-nav-button.v',
    route: ROUTES.UN_SDG,
  },
  {
    label: 'impact-type-nav-button.v',
    route: ROUTES.IMPACT_TYPES,
  },
  {
    label: 'impact-periods-nav-button.v',
    route: ROUTES.IMPACT_PERIODS,
  },
]

const ImpactsLibraryButtons = () => {
  return <LogNavigationButtons items={buttons} />
}

export { ImpactsLibraryButtons }
